import {TranslateService} from '@ngx-translate/core';
import {Alert} from '../utils/alert';

export class Error {
  message = 'HTTP response wrong';
  type: Error.Type | undefined;
  fields: string[] = [];
  values: any[] = [];

  getAlert(status: Alert.Status, translateService: TranslateService): Alert {
    return new Alert(
      status,
      'message.login',
      {
        key: this.getI18nKey(),
        params: this.getI18nData(translateService)
      }
    );
  }

  getI18nKey() {
    return 'error.message.' + (this.type ? this.type.toLowerCase() : Error.Type.NOT_VALID_DATA.toLowerCase());
  }

  getI18nData(translateService: TranslateService) {
    const data = {};
    if (this.fields) {
      let cpt = 0;
      for (const field of this.fields) {
        const fieldKey = 'error.field.' + field;
        const translatedField = translateService.instant(fieldKey);
        // @ts-ignore
        data['field' + (++cpt)] = translatedField !== fieldKey ? translatedField : field;
      }
    }
    if (this.values) {
      let cpt = 0;
      for (const value of this.values) {
        // @ts-ignore
        data['value' + (++cpt)] = value;
      }
    }

    return data;
  }

  getI18n(translateService: TranslateService) {
    return translateService.instant(this.getI18nKey(), this.getI18nData(translateService));
  }
}

export module Error {
  export enum Type {
    // noinspection JSUnusedGlobalSymbols
    REQUIRED_IF = 'REQUIRED_IF',
    NOT_A_NUMBER = 'NOT_A_NUMBER',
    EQUALS = 'EQUALS',
    MIN = 'MIN',
    NOT_EQUALS_TO = 'NOT_EQUALS_TO',
    NOT_VALID_ORGANIZATION = 'NOT_VALID_ORGANIZATION',
    NOT_UNIQUE = 'NOT_UNIQUE',
    NOT_VALID_DATA = 'NOT_VALID_DATA',
    NOT_VALID_ = 'NOT_VALID_',
    NOT_VALID_FIELD = 'NOT_VALID_FIELD',
    NOT_EQUALS = 'NOT_EQUALS',
    REQUIRED = 'REQUIRED',
    MAX = 'MAX',
    MAXLENGTH = 'MAXLENGTH',
    MINLENGTH = 'MINLENGTH',
    EMAIL = 'EMAIL',
    POSITIVE = 'POSITIVE',
    UNKNOWN_ERROR = 'UNKNOWN_ERROR',
    USER_HAVE_TO_CHANGE_PASSWORD = 'USER_HAVE_TO_CHANGE_PASSWORD'
  }

  export let getValueFromNgValidator = function (type: Error.Type, ngValidator: { [key: string]: any }): any[] {
    let values;
    switch (type) {
      case Error.Type.MIN:
        values = [ngValidator['min'].min];
        break;
      case Error.Type.MAX:
        values = [ngValidator['max'].max];
        break;
      case Error.Type.MAXLENGTH:
        values = [ngValidator['maxlength'].requiredLength];
        break;
      case Error.Type.MINLENGTH:
        values = [ngValidator['minlength'].requiredLength];
        break;
      default:
        values = [ngValidator.value];
        break;
    }

    return values;
  };

  export let getFieldFromNgValidator = function (type: Error.Type, fieldName: string, ngValidator: { [key: string]: any }): string[] {
    let field;
    switch (type) {
      case Error.Type.REQUIRED_IF:
        field = [ngValidator.field];
        break;
      default:
        field = [fieldName];
        break;
    }

    return field;
  };

  export let getTypeFromNgValidator = function (ngValidator: Error.Type) {
    let type: Error.Type = ngValidator;
    switch (ngValidator) {
      default:
        if (ngValidator.toUpperCase() === ngValidator) {
          type = ngValidator;
        } else {
          // @ts-ignore
          type = ngValidator.replace(/(.)([A-Z])/, '$1_$2').toUpperCase();
        }
        break;
    }
    return type;
  };
}
